<!--This template describes a decorative, introductory page (ie About)
    It is required to include:
    - PageHeader
    It's optional components include:
    - title_and_text
    - paragraph_and_image
    - multiple_image_carousel
    - image_carousela
    - card_and_card_banner
    - quote_banner
    -->

<template>
  <main class="pad">
    <div v-if="!loading">

      <!--Parralax image with page title and optional sub-heading-->

      <PageHeader
        v-if="page.meta.parent.meta.type == 'departments.DepartmentLandingPage'"
        :title="page.title"
        :logo_url="page.logo ? page.logo.meta.download_url : page.get_department_logo_url"
        :image_url="page.image ? page.image.meta.download_url : page.get_department_image_url"
        :subtitle="page.subtitle ? page.subtitle : ''"
        :dept_link="'/departmentlandingpage/'+parentSlug"
      >
      </PageHeader>

      <PageHeader
        v-else
        :title="page.title"
        :logo_url="page.logo ? page.logo.meta.download_url : page.get_homepage_logo_url"
        :image_url="page.image ? page.image.meta.download_url : page.get_homepage_image_url"
        :subtitle="page.subtitle ? page.subtitle : ''"
      >
      </PageHeader>

      <!--All other components are optional (user-decided) and follow:-->

      <template v-for="block in content">
        <component :is="block.type" :block="block" :key="block.id"></component>
      </template>
    </div>
  </main>
</template>

<script>
import shared from "@/shared";
import axios from "axios";
import api from "@/api"
import title_and_text_banner from "@/components/streamfields/landingPageComponents/title_and_text_banner.vue";
import paragraph_and_image_banner from "@/components/streamfields/landingPageComponents/paragraph_and_image_banner.vue";
import multiple_image_carousel from "@/components/streamfields/landingPageComponents/multiple_image_carousel.vue";
import image_carousel from "@/components/streamfields/landingPageComponents/image_carousel.vue";
import card_and_card_banner from "@/components/streamfields/landingPageComponents/card_and_card_banner.vue";
import quote_banner from "@/components/streamfields/quote_banner.vue";
import full_richtext from "@/components/streamfields/full_richtext.vue";
import parallax_image from "@/components/streamfields/parallax_image.vue";
import information_carousel from "@/components/streamfields/landingPageComponents/info_carousel/information_carousel.vue";
import FAQ_accordion from "@/components/streamfields/FAQ_accordion.vue";
import PageHeader from "@/views/PageHeader.vue";

export default {
  name: "AboutPage",
  props: {
    slug: String
  },
  data() {
    return {
      parentSlug: String,
      page: String,
      content: Array,
      loading: true
    };
  },
  mounted() {
    axios
      api.get("pages/" + this.slug)
      .then(response => {
        this.page = response.data;
        this.content = this.page.content;
        shared.getDepartmentSkinFromPage(response.data);
        this.parentSlug = shared.extractParentSlug(this.page.meta.parent.meta.html_url)
      })
      .catch(e => {
        this.errors.push(e);
      })
      .finally(() => (this.loading = false));
  },
  components: {
    title_and_text_banner,
    paragraph_and_image_banner,
    multiple_image_carousel,
    card_and_card_banner,
    quote_banner,
    image_carousel,
    full_richtext,
    parallax_image,
    information_carousel,
    FAQ_accordion,
    PageHeader
  }
};
</script>
